import styled from "styled-components";

export const FooterContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  /* height: 2.5rem; */
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FooterText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 900px) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;
  }
`;

export const FooterIcons = styled.div``;

export const Text = styled.div`
  font-size: 0.9em;
`;

export const Icon = styled.a`
  padding: 0.7em;
  text-decoration: none;
  color: white;
  font-size: 1.3em;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
    color: inherit;
  }
`;
